import React from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';

import { FieldTableType } from 'src/components/common/table/TypeCustom';

type RecordItemProps = {
  item: any;
  fields: FieldTableType[];
  borderBottom: string;
  isTotal?: boolean;
  discounts: any[];
};

const RecordItem: React.FC<RecordItemProps> = (props) => {
  const getDataItem = (field: string) => {
    return props.item[field] ? props.item[field] : '';
  };

  return (
    <TableRow
      hover
      key={props.item.id}
      sx={{
        '&:last-child td, &:last-child th': { border: '0px !important' },
        '& .MuiTableCell-root.MuiTableCell-body': {
          py: '4px',
          borderBottom: props.borderBottom,
        },
        height: '48px',
      }}
    >
      {props.fields.map((field, index: number) => (
        <TableCell key={index} component='td' align={field.align} scope='row' sx={{ cursor: 'pointer' }}>
          <Typography
            sx={{
              whiteSpace: 'pre-wrap',
              fontSize: '12px',
              fontWeight: props.isTotal ? 700 : 500,
              color: props.isTotal ? '#000' : '',
              lineHeight: '1.5rem'
            }}>
            {getDataItem(field.field)}
            {field.field === 'treatment' && getDataItem(field.field).includes('%') && props.discounts[0] && (
              <Typography
                sx={{
                  fontSize: '10px',
                  fontWeight: 400,
                  lineHeight: '12.2px',
                  color: 'rgb(204, 204, 204)',
                  ml: '-5px'
                }}>
                *割引対象施術
              </Typography>
            )}
            {field.field === 'treatment' && getDataItem(field.field).includes('%') && props.discounts[1] && (
              <Typography
                sx={{
                  fontSize: '10px',
                  fontWeight: 400,
                  lineHeight: '12.2px',
                  color: 'rgb(204, 204, 204)',
                  ml: '-5px'
                }}>
                ^千円未満の金額は切り上げて計算しています。
              </Typography>
            )}
          </Typography>
        </TableCell>
      ))}
    </TableRow>
  );
};

export default RecordItem;
